import type { FC, ReactNode } from 'react'
import { useTranslation } from '@/translations/i18n'

export interface ListingDetailsField {
	label: string
	value: ReactNode
}

interface ListingDetailsInfoBaseProps {
	title?: string
	fields: ListingDetailsField[]
}

export const ListingDetailsInfoBase: FC<ListingDetailsInfoBaseProps> = ({
	title,
	fields
}) => {
	const { t } = useTranslation()
	return (
		<div className='flex flex-col gap-2 overflow-auto pt-6 pl-4'>
			<h3 className='font-bold text-lg'>
				{title ?? t('luxe_submissions:submission_details')}
			</h3>
			<div className='flex flex-col'>
				{fields.map((item) => (
					<div
						className='grid grid-cols-[1fr_2fr] gap-4 border-neutral-200 border-b px-3 py-2.5 text-xs'
						key={item.label}
					>
						<span className='text-neutral-600'>{item.label}</span>
						<span className='font-medium text-neutral-700'>
							{item.value}
						</span>
					</div>
				))}
			</div>
		</div>
	)
}
